import { IStringString } from '@shared/model/types'

class Cookie {
  getAll = (): IStringString | null => {
    const allCookie = document.cookie
    if (allCookie) {
      const result: IStringString = {}
      const arrayOfCookie = document.cookie.split(';')
      arrayOfCookie.forEach((cookie) => {
        const [name, value] = cookie.split('=')
        const cleanedName = name.trim().replace(/["\s]/g, '')
        result[cleanedName] = value
      })
      return result
    }
    return null
  }

  get = (name: string): string | null => {
    const all = this.getAll()
    if (all) {
      const el = all[name]
      if (el) {
        return el
      }
      return null
    }
    return null
  }

  set = (name: string, value: string, expiration?: number, minutes?: boolean) => {
    let cookieString = `${name}=${value}`
    if (expiration) {
      const expirationDate = new Date()
      if (minutes) {
        expirationDate.setTime(expirationDate.getTime() + (expiration * 60 * 1000))
      } else {
        expirationDate.setTime(expirationDate.getTime() + (expiration * 24 * 60 * 60 * 1000))
      }
      cookieString += `;expires=${expirationDate.toUTCString()}`
    }
    document.cookie = cookieString
  }

  del = (name: string) => {
    document.cookie = `${name}=;expires=${new Date(0)}`
  }
}

export default new Cookie()
